module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("© Noam Chomsky 2002")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("Original edition published by South End Press in Cambridge, Massachusetts")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("This edition published in 2015 by")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("Haymarket Books")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("P.O. Box 180165")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("Chicago, IL 60618")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("773-583-7884")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("www.haymarketbooks.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("info@haymarketbooks.org")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("ISBN: 978-1-60846-442-5")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("Trade distribution:")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("In the US, Consortium Book Sales and Distribution, www.cbsd.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("All other countries, Publishers Group Worldwide, www.pgw.com")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("This book was published with the generous support of Lannan Foundation and Wallace Action Fund.")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("Cover design by Josh On. Cover photo of the aircraft carrier")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USS Ronald Reagan")]), _vm._v(" "), _c('span', [_vm._v("on the Pacific Ocean. Photo by U.S. Navy Mass Communication Specialist 3rd Class Dylan McCord.")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "body_ni"
  }, [_c('span', [_vm._v("Library of Congress Cataloging-in-Publication data is available.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f17752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Copyright.vue
// module id = 66
// module chunks = 0